.profile-card {
  height:100%;
  border: 1px solid var(--gray-500);
  display:flex;
  flex-direction:column;
  justify-content: space-between;
  //margin: 0 3rem;
  
  
  &-header {
    background-color: rgba(13, 110, 253, .1);
    border-bottom: 1px solid var(--gray-500);
    
  }
  &-icon {
    height: 80px;
    width: 80px;
    border-radius: 50%;
    border: 1px solid var(--gray-500);
    position: relative;
    top:40px;
    margin: 0 auto;
    background-color: #fff;
    text-align: center;
    overflow: hidden;
    img{
      width:100%;
      height:100%;
      object-fit: cover;
    }
    svg {
      position: relative;
      top:20px;
      fill: var(--primary);
      height: 40px;
      width: 40px;
    }
  }
  &-body {
    min-height:10rem;
    padding:3rem 1rem 2rem 1rem;
    text-align: center;
    height:100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    h2 {
      font-size:1.25rem;
      font-weight: 700;
    }
    a.btn {
      width:100%;
      font-weight: bolder;
      margin-top:1rem;
      svg {
        
        margin-left:1rem;
      }
    }

    
  }

}